import { render, staticRenderFns } from "./DoctorListSelectAllAndNew.vue?vue&type=template&id=d34fd3f6&scoped=true"
import script from "./DoctorListSelectAllAndNew.vue?vue&type=script&lang=js"
export * from "./DoctorListSelectAllAndNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34fd3f6",
  null
  
)

export default component.exports